module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_1@2x.65990c16.png";